import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4b4a349b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "simple-table mb-0"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "id"),
    /*#__PURE__*/_createElementVNode("th", null, "Difficulty"),
    /*#__PURE__*/_createElementVNode("th", null, "Validation")
  ])
], -1))
const _hoisted_3 = { class: "index-col" }
const _hoisted_4 = { class: "id-col" }
const _hoisted_5 = { class: "difficulty-col" }
const _hoisted_6 = {
  key: 0,
  class: "question-difficulty"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "validation-col" }
const _hoisted_9 = {
  key: 1,
  class: "start-message"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No questions authored.", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "tools-buttons" }
const _hoisted_13 = {
  key: 0,
  class: "btn-3 disabled margin-r-standard",
  "data-testing": "qti-card-btn-preview"
}

import { computed, onMounted, PropType, ref, watch } from "vue";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";
import {
  buildQuestionsHTMLArray,
  isDifficultyVisible
} from "@/utils/product/qti-to-html-helper";
import { QTIQuestionHTML } from "@/models/qti.model";
import Hint from "@/components/Hint.vue";
import { ContentStructureSection } from "@/models/content-structure.model";
import { mdiCheck, mdiPresentationPlay } from "@mdi/js";
import { useUIContentStore } from "@/stores/ui-content.store";
import { useProductsStore } from "@/stores/products.store";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'QTI',
  props: {
  section: {
    type: Object as PropType<ContentStructureSection>,
    required: true
  },
  isContentAuthoringTier2FeatureEnabled: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const route = useRoute();
const router = useRouter();
const uiContentStore = useUIContentStore();
const productsStore = useProductsStore();

const props = __props;

const isQTIEditorPage = ref<boolean>(false);

const isReloading = ref<boolean>(false);
const reloadQTI = () => {
  isReloading.value = true;
  productsStore
    .populateProductDetails(Number(route.params.productId))
    .then(() => (isReloading.value = false));
};

const isQuestionsLoading = ref<boolean>(true);
const questions = ref<QTIQuestionHTML[]>([]);
const getQuestions = async (): Promise<void> => {
  isQuestionsLoading.value = true;
  const variables = props.section.document_variables
    ? props.section.document_variables
    : [];
  if (props.section.document) {
    const doc = props.section.document ? props.section.document : "";
    questions.value = await buildQuestionsHTMLArray(doc, variables, false);
  }
  isQuestionsLoading.value = false;
};
onMounted(() => {
  getQuestions();
  isQTIEditorPage.value = route.name === "qti-editor";
});
uiContentStore.$subscribe((mutation, state) => {
  const newVal = state.sectionToDisplay;
  if (newVal) {
    getQuestions();
  }
});
watch(
  () => router.currentRoute.value,
  newVal => {
    isQTIEditorPage.value = newVal.name === "qti-editor";
  },
  { immediate: true }
);
watch(
  () => props.section.document,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      getQuestions();
    }
  }
);

const isStartMessageVisible = computed<boolean>(() => {
  return (
    !isQuestionsLoading.value &&
    (!questions.value || questions.value.length === 0)
  );
});

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['margin-b-standard', { updating: isReloading.value }]),
    "data-testing": "qti-card"
  }, [
    _createVNode(RightSidebarTitle, { title: 'QTI Question Bank' }),
    (!isStartMessageVisible.value)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: question.questionId
              }, [
                _createElementVNode("td", _hoisted_3, _toDisplayString(index + 1), 1),
                _createElementVNode("td", _hoisted_4, _toDisplayString(question.questionId), 1),
                _createElementVNode("td", _hoisted_5, [
                  (_unref(isDifficultyVisible)(question.difficulty))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(question.difficulty), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, "Not set"))
                ]),
                _createElementVNode("td", _hoisted_8, [
                  (question.errors.length > 0)
                    ? (_openBlock(), _createBlock(Hint, {
                        key: 0,
                        type: 'warning',
                        position: 'left',
                        iconSize: 16
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.errors, (error, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error) + " required", 1))
                            }), 128))
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_component_SVGIcon, {
                        key: 1,
                        path: _unref(mdiCheck),
                        type: "is-success"
                      }, null, 8, ["path"]))
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)),
    _createElementVNode("div", _hoisted_12, [
      (!isStartMessageVisible.value && !__props.isContentAuthoringTier2FeatureEnabled)
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
            _createVNode(_component_SVGIcon, { path: _unref(mdiPresentationPlay) }, null, 8, ["path"]),
            _createTextVNode(" Preview ")
          ]))
        : _createCommentVNode("", true),
      (!isStartMessageVisible.value && __props.isContentAuthoringTier2FeatureEnabled)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "btn-3",
            "data-testing": "qti-card-btn-preview",
            disabled: !__props.isContentAuthoringTier2FeatureEnabled,
            event: __props.isContentAuthoringTier2FeatureEnabled ? 'click' : '',
            to: {
          name: 'qti-preview',
          params: {
            productId: _unref(uiContentStore).sectionToDisplay.productId,
            sectionId: _unref(uiContentStore).sectionToDisplay.sectionId
          }
        }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SVGIcon, { path: _unref(mdiPresentationPlay) }, null, 8, ["path"]),
              _createTextVNode(" Preview ")
            ]),
            _: 1
          }, 8, ["disabled", "event", "to"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})